import {
  ModalsStateContext,
  ModalsDispatchContext,
} from "./CommonModal.context";
import JoinPolicyModal from "components/Common/Modal/JoinPolicy/JoinPolicy.container";
import PasswordInitModal from "components/Common/Modal/PasswordInit";
interface IModalProvider {
  children: React.ReactNode;
}
const CommonModalsProvider = ({ children }: IModalProvider) => {
  const dispatch = {};
  const state = {};

  return (
    <ModalsDispatchContext.Provider value={dispatch}>
      <ModalsStateContext.Provider value={state}>
        {children}
        <JoinPolicyModal />
        <PasswordInitModal />
      </ModalsStateContext.Provider>
    </ModalsDispatchContext.Provider>
  );
};

export default CommonModalsProvider;
